import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 80px;

  ${media.lessThan('md')`
    display: block;

    img {
      width: 260px;
      margin: 20px auto 0;
    }
  `};
`;
